import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { ThemeProvider } from './contexts/ThemeContext'
import 'material-icons/iconfont/material-icons.css'
import './index.css'
import { isEmbedded } from './lib/embed'
import { initEmbedBridge } from './lib/embedBridge'

// Inside a partner iframe: apply embed CSS now, then load the runtime policy and request a
// session. ProtectedRoute shows "Connecting…" until the handshake lands.
if (isEmbedded()) void initEmbedBridge()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
